import React, { useContext } from 'react';
import Typed from 'react-typed';
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { FiArrowRight, FiDownload } from 'react-icons/fi';
import ParticleBackground from '../Particle/ParticleBackground';
import './InfoSection.css';
import './Animation.css';
import { ThemeContext } from '../../contexts/ThemeContext';

import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  StatusPill,
  Greeting,
  Hello,
  NameWrap,
  Typing,
  TypedM,
  TagLine,
  CtaRow,
  Button,
  GhostButton,
  SocialRow,
  SocialLink,
  Buttons,
  ColorLabel,
  Toggle,
  ImgWrapper,
  ImgFrame,
  Glow,
  FloatBadge,
  ScrollCue,
} from './InfoSection.elements';

const myPhoto1 = `${process.env.PUBLIC_URL}/hero_enes.JPG`;

const fade = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: 0.15 * i, ease: 'easeOut' },
  }),
};

function InfoSection({
  headline,
  description,
  roles = ['Fullstack Product Engineer'],
  buttonLabel,
  cvUrl,
  imgStart,
  start,
}) {
  const { switchTheme } = useContext(ThemeContext);

  const colors = [
    { key: 'red', hex: '#F20000' },
    { key: 'green', hex: '#0cf702' },
    { key: 'yellow', hex: '#fccf14' },
    { key: 'blue', hex: '#1cc5dc' },
    { key: 'purple', hex: '#330066' },
  ];

  return (
    <InfoSec id="home">
      <ParticleBackground />

      <InfoRow imgStart={imgStart}>
        <InfoColumn>
          <TextWrapper>
            <StatusPill variants={fade} custom={0} initial="hidden" animate="visible">
              <span className="dot" />
              Available for new opportunities
            </StatusPill>

            <Greeting variants={fade} custom={1} initial="hidden" animate="visible">
              Hello,{headline} <Hello>Enes Güngör</Hello>
            </Greeting>

            <NameWrap variants={fade} custom={1.5} initial="hidden" animate="visible">
              <svg id="logo" width="170" height="74" viewBox="0 0 170 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 57.05V5.075H33.725V11.3H9.275V26.75H31.025V32.825H9.275V50.825H35.6V57.05H2Z" stroke="#fff" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M44.3967 19.175C45.9967 18.775 48.1217 18.35 50.7717 17.9C53.4217 17.45 56.4717 17.225 59.9217 17.225C63.0217 17.225 65.5967 17.675 67.6467 18.575C69.6967 19.425 71.3217 20.65 72.5217 22.25C73.7717 23.8 74.6467 25.675 75.1467 27.875C75.6467 30.075 75.8967 32.5 75.8967 35.15V57.05H68.9217V36.65C68.9217 34.25 68.7467 32.2 68.3967 30.5C68.0967 28.8 67.5717 27.425 66.8217 26.375C66.0717 25.325 65.0717 24.575 63.8217 24.125C62.5717 23.625 61.0217 23.375 59.1717 23.375C58.4217 23.375 57.6467 23.4 56.8467 23.45C56.0467 23.5 55.2717 23.575 54.5217 23.675C53.8217 23.725 53.1717 23.8 52.5717 23.9C52.0217 24 51.6217 24.075 51.3717 24.125V57.05H44.3967V19.175Z" stroke="#FDFDFD" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M85.2881 37.625C85.2881 34.175 85.7881 31.175 86.7881 28.625C87.7881 26.025 89.1131 23.875 90.7631 22.175C92.4131 20.475 94.3131 19.2 96.4631 18.35C98.6131 17.5 100.813 17.075 103.063 17.075C108.313 17.075 112.338 18.725 115.138 22.025C117.938 25.275 119.338 30.25 119.338 36.95C119.338 37.25 119.338 37.65 119.338 38.15C119.338 38.6 119.313 39.025 119.263 39.425H92.5631C92.8631 43.475 94.0381 46.55 96.0881 48.65C98.1381 50.75 101.338 51.8 105.688 51.8C108.138 51.8 110.188 51.6 111.838 51.2C113.538 50.75 114.813 50.325 115.663 49.925L116.638 55.775C115.788 56.225 114.288 56.7 112.138 57.2C110.038 57.7 107.638 57.95 104.938 57.95C101.538 57.95 98.5881 57.45 96.0881 56.45C93.6381 55.4 91.6131 53.975 90.0131 52.175C88.4131 50.375 87.2131 48.25 86.4131 45.8C85.6631 43.3 85.2881 40.575 85.2881 37.625ZM112.063 33.8C112.113 30.65 111.313 28.075 109.663 26.075C108.063 24.025 105.838 23 102.988 23C101.388 23 99.9631 23.325 98.7131 23.975C97.5131 24.575 96.4881 25.375 95.6381 26.375C94.7881 27.375 94.1131 28.525 93.6131 29.825C93.1631 31.125 92.8631 32.45 92.7131 33.8H112.063Z" stroke="#FDFDFD" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M138.433 52.025C141.283 52.025 143.383 51.65 144.733 50.9C146.133 50.15 146.833 48.95 146.833 47.3C146.833 45.6 146.158 44.25 144.808 43.25C143.458 42.25 141.233 41.125 138.133 39.875C136.633 39.275 135.183 38.675 133.783 38.075C132.433 37.425 131.258 36.675 130.258 35.825C129.258 34.975 128.458 33.95 127.858 32.75C127.258 31.55 126.958 30.075 126.958 28.325C126.958 24.875 128.233 22.15 130.783 20.15C133.333 18.1 136.808 17.075 141.208 17.075C142.308 17.075 143.408 17.15 144.508 17.3C145.608 17.4 146.633 17.55 147.583 17.75C148.533 17.9 149.358 18.075 150.058 18.275C150.808 18.475 151.383 18.65 151.783 18.8L150.508 24.8C149.758 24.4 148.583 24 146.983 23.6C145.383 23.15 143.458 22.925 141.208 22.925C139.258 22.925 137.558 23.325 136.108 24.125C134.658 24.875 133.933 26.075 133.933 27.725C133.933 28.575 134.083 29.325 134.383 29.975C134.733 30.625 135.233 31.225 135.883 31.775C136.583 32.275 137.433 32.75 138.433 33.2C139.433 33.65 140.633 34.125 142.033 34.625C143.883 35.325 145.533 36.025 146.983 36.725C148.433 37.375 149.658 38.15 150.658 39.05C151.708 39.95 152.508 41.05 153.058 42.35C153.608 43.6 153.883 45.15 153.883 47C153.883 50.6 152.533 53.325 149.833 55.175C147.183 57.025 143.383 57.95 138.433 57.95C134.983 57.95 132.283 57.65 130.333 57.05C128.383 56.5 127.058 56.075 126.358 55.775L127.633 49.775C128.433 50.075 129.708 50.525 131.458 51.125C133.208 51.725 135.533 52.025 138.433 52.025Z" stroke="#FDFDFD" strokeWidth="4" mask="url(#path-1-outside-1)" />
              </svg>
              <svg width="258" height="75" viewBox="0 0 258 75" fill="none" xmlns="http://www.w3.org/2000/svg" id="logo1">
                <path d="M28.525 13.15C23.175 13.15 19.075 14.825 16.225 18.175C13.425 21.475 12.025 26.075 12.025 31.975C12.025 34.775 12.35 37.35 13 39.7C13.7 42 14.7 43.975 16 45.625C17.35 47.275 19 48.575 20.95 49.525C22.95 50.425 25.275 50.875 27.925 50.875C29.575 50.875 31 50.825 32.2 50.725C33.4 50.575 34.35 50.4 35.05 50.2V31.525H44.5V56.5C43.2 57 41 57.55 37.9 58.15C34.8 58.75 31.225 59.05 27.175 59.05C23.425 59.05 20 58.45 16.9 57.25C13.8 56.05 11.15 54.3 8.95 52C6.8 49.7 5.125 46.875 3.925 43.525C2.725 40.175 2.125 36.325 2.125 31.975C2.125 27.625 2.775 23.775 4.075 20.425C5.425 17.075 7.25 14.25 9.55 11.95C11.85 9.60001 14.55 7.82501 17.65 6.62501C20.75 5.42501 24.05 4.82501 27.55 4.82501C29.95 4.82501 32.075 5.00001 33.925 5.35001C35.825 5.65001 37.45 6.00001 38.8 6.40001C40.15 6.80001 41.25 7.22501 42.1 7.67501C43 8.12501 43.625 8.45001 43.975 8.65001L41.125 16.375C39.625 15.475 37.75 14.725 35.5 14.125C33.3 13.475 30.975 13.15 28.525 13.15Z" stroke="white" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M87.1463 56.8C85.3963 57.25 83.1213 57.7 80.3213 58.15C77.5213 58.65 74.4463 58.9 71.0963 58.9C67.9463 58.9 65.2963 58.45 63.1463 57.55C61.0463 56.65 59.3463 55.4 58.0463 53.8C56.7963 52.2 55.8963 50.3 55.3463 48.1C54.7963 45.85 54.5213 43.4 54.5213 40.75V18.775H63.5963V39.325C63.5963 43.525 64.1963 46.525 65.3963 48.325C66.6463 50.125 68.7963 51.025 71.8463 51.025C72.9463 51.025 74.0963 50.975 75.2963 50.875C76.5463 50.775 77.4713 50.65 78.0713 50.5V18.775H87.1463V56.8ZM63.0713 12.325C61.7213 12.325 60.5463 11.875 59.5463 10.975C58.5463 10.075 58.0463 8.85001 58.0463 7.30001C58.0463 5.75001 58.5463 4.52501 59.5463 3.62501C60.5463 2.67501 61.7213 2.20001 63.0713 2.20001C64.4213 2.20001 65.5963 2.67501 66.5963 3.62501C67.6463 4.52501 68.1713 5.75001 68.1713 7.30001C68.1713 8.85001 67.6463 10.075 66.5963 10.975C65.5963 11.875 64.4213 12.325 63.0713 12.325ZM78.5963 12.325C77.2463 12.325 76.0463 11.875 74.9963 10.975C73.9963 10.075 73.4963 8.85001 73.4963 7.30001C73.4963 5.75001 73.9963 4.52501 74.9963 3.62501C76.0463 2.67501 77.2463 2.20001 78.5963 2.20001C79.9463 2.20001 81.1213 2.67501 82.1213 3.62501C83.1213 4.52501 83.6213 5.75001 83.6213 7.30001C83.6213 8.85001 83.1213 10.075 82.1213 10.975C81.1213 11.875 79.9463 12.325 78.5963 12.325Z" stroke="white" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M98.6969 20.05C100.447 19.55 102.722 19.075 105.522 18.625C108.322 18.175 111.422 17.95 114.822 17.95C118.022 17.95 120.697 18.4 122.847 19.3C124.997 20.15 126.697 21.375 127.947 22.975C129.247 24.525 130.147 26.425 130.647 28.675C131.197 30.875 131.472 33.3 131.472 35.95V58H122.397V37.375C122.397 35.275 122.247 33.5 121.947 32.05C121.697 30.55 121.247 29.35 120.597 28.45C119.997 27.5 119.147 26.825 118.047 26.425C116.997 25.975 115.697 25.75 114.147 25.75C112.997 25.75 111.797 25.825 110.547 25.975C109.297 26.125 108.372 26.25 107.772 26.35V58H98.6969V20.05Z" stroke="white" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M149.694 37.375C149.694 41.225 150.519 44.05 152.169 45.85C153.869 47.6 156.044 48.475 158.694 48.475C160.144 48.475 161.494 48.275 162.744 47.875C164.044 47.475 165.094 47 165.894 46.45V26.125C165.244 25.975 164.444 25.85 163.494 25.75C162.544 25.6 161.344 25.525 159.894 25.525C156.594 25.525 154.069 26.625 152.319 28.825C150.569 30.975 149.694 33.825 149.694 37.375ZM174.969 54.025C174.969 60.275 173.369 64.85 170.169 67.75C167.019 70.65 162.169 72.1 155.619 72.1C153.219 72.1 150.869 71.9 148.569 71.5C146.319 71.1 144.269 70.575 142.419 69.925L144.069 62.2C145.619 62.85 147.369 63.375 149.319 63.775C151.319 64.175 153.469 64.375 155.769 64.375C159.419 64.375 162.019 63.625 163.569 62.125C165.119 60.625 165.894 58.4 165.894 55.45V53.95C164.994 54.4 163.794 54.85 162.294 55.3C160.844 55.75 159.169 55.975 157.269 55.975C154.769 55.975 152.469 55.575 150.369 54.775C148.319 53.975 146.544 52.8 145.044 51.25C143.594 49.7 142.444 47.775 141.594 45.475C140.794 43.125 140.394 40.425 140.394 37.375C140.394 34.525 140.819 31.9 141.669 29.5C142.569 27.1 143.844 25.05 145.494 23.35C147.194 21.65 149.244 20.325 151.644 19.375C154.044 18.425 156.769 17.95 159.819 17.95C162.769 17.95 165.569 18.175 168.219 18.625C170.869 19.075 173.119 19.55 174.969 20.05V54.025Z" stroke="white" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M221.989 38.35C221.989 41.45 221.539 44.275 220.639 46.825C219.739 49.375 218.464 51.55 216.814 53.35C215.164 55.15 213.164 56.55 210.814 57.55C208.514 58.55 205.964 59.05 203.164 59.05C200.364 59.05 197.814 58.55 195.514 57.55C193.214 56.55 191.239 55.15 189.589 53.35C187.939 51.55 186.639 49.375 185.689 46.825C184.789 44.275 184.339 41.45 184.339 38.35C184.339 35.25 184.789 32.45 185.689 29.95C186.639 27.4 187.939 25.225 189.589 23.425C191.289 21.625 193.289 20.25 195.589 19.3C197.889 18.3 200.414 17.8 203.164 17.8C205.914 17.8 208.439 18.3 210.739 19.3C213.089 20.25 215.089 21.625 216.739 23.425C218.389 25.225 219.664 27.4 220.564 29.95C221.514 32.45 221.989 35.25 221.989 38.35ZM212.689 38.35C212.689 34.45 211.839 31.375 210.139 29.125C208.489 26.825 206.164 25.675 203.164 25.675C200.164 25.675 197.814 26.825 196.114 29.125C194.464 31.375 193.639 34.45 193.639 38.35C193.639 42.3 194.464 45.425 196.114 47.725C197.814 50.025 200.164 51.175 203.164 51.175C206.164 51.175 208.489 50.025 210.139 47.725C211.839 45.425 212.689 42.3 212.689 38.35ZM195.364 12.325C194.014 12.325 192.839 11.875 191.839 10.975C190.839 10.075 190.339 8.85001 190.339 7.30001C190.339 5.75001 190.839 4.52501 191.839 3.62501C192.839 2.67501 194.014 2.20001 195.364 2.20001C196.714 2.20001 197.889 2.67501 198.889 3.62501C199.939 4.52501 200.464 5.75001 200.464 7.30001C200.464 8.85001 199.939 10.075 198.889 10.975C197.889 11.875 196.714 12.325 195.364 12.325ZM210.889 12.325C209.539 12.325 208.339 11.875 207.289 10.975C206.289 10.075 205.789 8.85001 205.789 7.30001C205.789 5.75001 206.289 4.52501 207.289 3.62501C208.339 2.67501 209.539 2.20001 210.889 2.20001C212.239 2.20001 213.414 2.67501 214.414 3.62501C215.414 4.52501 215.914 5.75001 215.914 7.30001C215.914 8.85001 215.414 10.075 214.414 10.975C213.414 11.875 212.239 12.325 210.889 12.325Z" stroke="white" strokeWidth="4" mask="url(#path-1-outside-1)" />
                <path d="M253.688 26.95C252.938 26.7 251.888 26.45 250.538 26.2C249.238 25.9 247.713 25.75 245.963 25.75C244.963 25.75 243.888 25.85 242.738 26.05C241.638 26.25 240.863 26.425 240.413 26.575V58H231.338V20.65C233.088 20 235.263 19.4 237.863 18.85C240.513 18.25 243.438 17.95 246.638 17.95C247.238 17.95 247.938 18 248.738 18.1C249.538 18.15 250.338 18.25 251.138 18.4C251.938 18.5 252.713 18.65 253.463 18.85C254.213 19 254.813 19.15 255.263 19.3L253.688 26.95Z" stroke="white" strokeWidth="4" mask="url(#path-1-outside-1)" />
              </svg>
            </NameWrap>

            <Typing variants={fade} custom={2} initial="hidden" animate="visible">
              I'm a{' '}
              <TypedM>
                <Typed
                  className="typed"
                  loop
                  typeSpeed={55}
                  backSpeed={45}
                  strings={roles}
                  backDelay={1400}
                  loopCount={0}
                  showCursor
                  cursorChar="|"
                />
              </TypedM>
            </Typing>

            <TagLine variants={fade} custom={2.5} initial="hidden" animate="visible">
              {description}
            </TagLine>

            <CtaRow variants={fade} custom={3} initial="hidden" animate="visible">
              <Button to="contact" smooth duration={500} spy exact="true" offset={-80}>
                {buttonLabel} <FiArrowRight />
              </Button>
              {cvUrl && (
                <GhostButton href={cvUrl} target="_blank" rel="noreferrer">
                  <FiDownload /> Download CV
                </GhostButton>
              )}
            </CtaRow>

            <SocialRow variants={fade} custom={3.5} initial="hidden" animate="visible">
              <SocialLink href="https://github.com/CodderEnesG" target="_blank" rel="noreferrer" aria-label="GitHub">
                <FaGithub />
              </SocialLink>
              <SocialLink
                href="https://www.linkedin.com/in/enes-g%C3%BCng%C3%B6r-658895205/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/bizenessg/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </SocialLink>
            </SocialRow>

            <Buttons variants={fade} custom={4} initial="hidden" animate="visible">
              <ColorLabel>Theme</ColorLabel>
              {colors.map((c) => (
                <Toggle
                  key={c.key}
                  style={{ backgroundColor: c.hex }}
                  onClick={() => switchTheme(c.key)}
                />
              ))}
            </Buttons>
          </TextWrapper>
        </InfoColumn>

        <InfoColumn>
          <ImgWrapper
            initial={{ scale: 0.94 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            start={start}
          >
            <Glow />
            <ImgFrame>
              <img
                src={myPhoto1}
                alt="Enes Güngör"
                width="760"
                height="920"
                fetchpriority="high"
                loading="eager"
                decoding="async"
              />
            </ImgFrame>
            <FloatBadge
              className="top"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.5 }}
            >
              <strong>6+ yrs</strong>
              <span>Shipping products</span>
            </FloatBadge>
            <FloatBadge
              className="bottom"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9, duration: 0.5 }}
            >
              <strong>Founder</strong>
              <span>Product Engineer</span>
            </FloatBadge>
          </ImgWrapper>
        </InfoColumn>
      </InfoRow>

      <ScrollCue to="about" smooth duration={500} spy exact="true" offset={-80}>
        <span className="mouse">
          <span className="wheel" />
        </span>
        Scroll
      </ScrollCue>
    </InfoSec>
  );
}

export default InfoSection;
